import findClassToken from '../../../breakpoint-editing/helpers/find-class-token';
import removeClassTokens from '../../../breakpoint-editing/helpers/remove-class-tokens';
import upsertClassToken from '../../../breakpoint-editing/helpers/upsert-class-token';
import breakpoints, { breakpointPrefixByKey } from '../../constants/breakpoints';
import { targetClassesConfig } from '../../constants/target-classes';

const BRACKETED_VALUE_PATTERN = /^\[(.*)\]$/;

const getClassTokenName = (target) => targetClassesConfig[target]?.tokenName || target;

const serialize = (target, value) => {
  const tokenName = getClassTokenName(target);
  const stringValue = String(value);

  return stringValue.includes('[')
    ? `${tokenName}-${stringValue}`
    : `${tokenName}-[${stringValue}]`;
};

const matches = (target, body) => {
  const tokenName = getClassTokenName(target);

  return body === tokenName || body.startsWith(`${tokenName}-[`);
};

const parse = (target, body) => {
  const tokenName = getClassTokenName(target);
  const raw = body.slice(tokenName.length + 1);
  const bracketedMatch = raw.match(BRACKETED_VALUE_PATTERN);

  return bracketedMatch ? bracketedMatch[1] : raw;
};

const readValues = ({ element, target }) => {
  const classAttribute = element?.getAttribute('class') || '';
  const tokenName = getClassTokenName(target);

  return breakpoints.reduce((collectedValues, { key, prefix }) => {
    const token = findClassToken(classAttribute, {
      prefix,
      matchesToken: (body) => matches(target, body),
    });

    if (token === null || token === tokenName) {
      return collectedValues;
    }

    return { ...collectedValues, [key]: parse(target, token) };
  }, {});
};

const patch = ({ currentClass = '', target, value, breakpointKey }) =>
  upsertClassToken(currentClass, {
    prefix: breakpointPrefixByKey[breakpointKey],
    matchesToken: (body) => matches(target, body),
    token: serialize(target, value),
  });

const remove = ({ currentClass = '', target, breakpointKey }) =>
  removeClassTokens(currentClass, {
    prefix: breakpointPrefixByKey[breakpointKey],
    matchesToken: (body) => matches(target, body),
  });

export default {
  serialize,
  matches,
  parse,
  readValues,
  patch,
  remove,
};
